import React, { useEffect, useRef } from "react";
import "./style.css";

const mapTickerItem = (data) => {
  return data.map((item) => (
    <div
      key={item.id}
      className="tw-flex tw-gap-1 tw-text-[12px] tw-font-nmreg tw-text-white"
    >
      <div className="tw-uppercase">{item.name}</div>
      <div>{item.price}</div>
      <div
        className={`${
          Number(item.percent) > 0 ? "tw-text-customGreen" : "tw-text-customRed"
        }`}
      >
        {item.percent}%
      </div>
      <div className="tw-flex tw-items-center">
        <div
          className={`tw-w-0 tw-h-0 tw-border-l-[4px] tw-border-l-transparent tw-border-r-[4px] tw-border-r-transparent tw-border-t-[6px] ${
            Number(item.percent) > 0
              ? "tw-border-t-customGreen tw-rotate-180"
              : "tw-border-t-customRed tw-rotate-0"
          }`}
        ></div>
      </div>
    </div>
  ));
};

const TickerTape = ({ data }) => {
  const tickerItems = mapTickerItem(data);
  return (
    <div className="basic-styling ticker-tape-container">
      <div className="ticker-tape" aria-hidden="true">
        {tickerItems}
      </div>
      <div className="ticker-tape" aria-hidden="true">
        {tickerItems}
      </div>
    </div>
  );
};

export default TickerTape;
